// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.specialties__list {
    padding: var(--space-x2-and-half) var(--space);
    display: grid;
    grid-template-columns:  1fr 1fr;
    column-gap: var(--space-and-half);
    row-gap: var(--space-half);
}
.specialties__list__specialty {
    border: 2px solid var(--secondary-light-color);
    border-radius: var(--space-and-half);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--space-half) var(--space);
}
.specialties__list__specialty:focus {
    background-color: var(--focused-sb-bg-color);
}
.specialties__list__specialty:hover {
    cursor: pointer;
    background-color: var(--hover-sb-bg-color);
}
.specialties__list__specialty:active {
    background-color: var(--active-sb-bg-color);
}
.specialties__list__specialty p {
    font-family: var(--secondary-font) !important;
    font-style: normal !important;
    font-weight: var(--font-bold) !important;
    font-size: var(--space-half-quarter) !important;
    line-height: var(--space) !important;
    display: flex;
    align-items: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--primary-very-dark-color);
}
.specialties__list__specialty img {
    width: var(--space);
    height: var(--space);
}
.specialties__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.specialties-form__form__input {
    padding: var(--space-half) var(--space);
}


/*Input style */
.specialties-form__form__input input{
    /* background-color: var(--primary-very-light-color); */
    background: transparent;
    border: var(--input-field-border);
    padding: var(--space) var(--space-and-half);
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    max-height: var(--space-x3);
}

.specialties-form__form__input input:focus {
    border: var(--input-field-border-focus);
}

/* label style */

.specialties-form__form__input label {
    position: absolute;
    /*top: calc( var(--space-half) * -1 );*/
    left: var(--space);
    background-color: var(--primary-very-light-color);
    font-weight: var(--font-bold);
    font-family: var(--secondary-font);
    line-height: var(--space);
    /*font-size: var(--space-half-quarter);*/
    letter-spacing: 0.004em;
    color: var(--primary-dark-color);
    text-transform: uppercase;
    padding: 0 var(--space-half);
}


.specialties-form__form__input div{
    border-radius: 0px;
    padding: 0px !important;
}

.specialties-form__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-specialties-modal/ProfileSpecialtiesModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,aAAa;IACb,+BAA+B;IAC/B,iCAAiC;IACjC,0BAA0B;AAC9B;AACA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uCAAuC;AAC3C;AACA;IACI,4CAA4C;AAChD;AACA;IACI,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,6CAA6C;IAC7C,6BAA6B;IAC7B,wCAAwC;IACxC,+CAA+C;IAC/C,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;AACzC;AACA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;AAC3C;;;AAGA,eAAe;AACf;IACI,uDAAuD;IACvD,uBAAuB;IACvB,iCAAiC;IACjC,2CAA2C;IAC3C,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,iDAAiD;IACjD,6BAA6B;IAC7B,kCAAkC;IAClC,yBAAyB;IACzB,wCAAwC;IACxC,uBAAuB;IACvB,gCAAgC;IAChC,yBAAyB;IACzB,4BAA4B;AAChC;;;AAGA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".specialties__list {\n    padding: var(--space-x2-and-half) var(--space);\n    display: grid;\n    grid-template-columns:  1fr 1fr;\n    column-gap: var(--space-and-half);\n    row-gap: var(--space-half);\n}\n.specialties__list__specialty {\n    border: 2px solid var(--secondary-light-color);\n    border-radius: var(--space-and-half);\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n}\n.specialties__list__specialty:focus {\n    background-color: var(--focused-sb-bg-color);\n}\n.specialties__list__specialty:hover {\n    cursor: pointer;\n    background-color: var(--hover-sb-bg-color);\n}\n.specialties__list__specialty:active {\n    background-color: var(--active-sb-bg-color);\n}\n.specialties__list__specialty p {\n    font-family: var(--secondary-font) !important;\n    font-style: normal !important;\n    font-weight: var(--font-bold) !important;\n    font-size: var(--space-half-quarter) !important;\n    line-height: var(--space) !important;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--primary-very-dark-color);\n}\n.specialties__list__specialty img {\n    width: var(--space);\n    height: var(--space);\n}\n.specialties__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.specialties-form__form__input {\n    padding: var(--space-half) var(--space);\n}\n\n\n/*Input style */\n.specialties-form__form__input input{\n    /* background-color: var(--primary-very-light-color); */\n    background: transparent;\n    border: var(--input-field-border);\n    padding: var(--space) var(--space-and-half);\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    max-height: var(--space-x3);\n}\n\n.specialties-form__form__input input:focus {\n    border: var(--input-field-border-focus);\n}\n\n/* label style */\n\n.specialties-form__form__input label {\n    position: absolute;\n    /*top: calc( var(--space-half) * -1 );*/\n    left: var(--space);\n    background-color: var(--primary-very-light-color);\n    font-weight: var(--font-bold);\n    font-family: var(--secondary-font);\n    line-height: var(--space);\n    /*font-size: var(--space-half-quarter);*/\n    letter-spacing: 0.004em;\n    color: var(--primary-dark-color);\n    text-transform: uppercase;\n    padding: 0 var(--space-half);\n}\n\n\n.specialties-form__form__input div{\n    border-radius: 0px;\n    padding: 0px !important;\n}\n\n.specialties-form__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
